'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loader = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _request_collator = require('./request_collator');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Loader = exports.Loader = function () {
  function Loader(dataService, retriever, extractorTuples) {
    var _this = this;

    _classCallCheck(this, Loader);

    this.dataService = dataService;
    this.retriever = retriever;

    this.extractors = new Map();
    extractorTuples.forEach(function (t) {
      return _this.extractors.set(t[0], t[1]);
    });

    this.collator = new _request_collator.RequestCollator();
  }

  _createClass(Loader, [{
    key: 'addExtractor',
    value: function addExtractor(key, extractor) {
      this.extractors.set(key, extractor);
    }
  }, {
    key: 'loadThroughCache',
    value: function loadThroughCache(key) {
      var value = this.dataService.retrieve(key);
      if (value !== undefined) {
        return Promise.resolve(value);
      } else {
        return this._load().then(this.extractors.get(key));
      }
    }

    // Private

  }, {
    key: '_load',
    value: function _load() {
      var _this2 = this;

      return this.collator.createOrReuse(this.retriever).then(function (data) {
        _this2.extractors.forEach(function (extractor, key) {
          _this2.dataService.store(key, extractor(data));
        });
        return data;
      });
    }
  }]);

  return Loader;
}();